// src/utils/facilityTransferApi.js
//
// Handing a facility over to its real owner (backend routes/facilityTransfers.ts):
// invitations sent by an admin or the facility's ambassador, and the
// public claim link the owner opens. Errors carry the backend's code in
// err.message (WRONG_ACCOUNT, TRANSFER_EXPIRED, ...).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

async function call(method, path, token, body) {
  const r = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(data.code || data.error || `HTTP_${r.status}`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const listTransfers = (facilityId, token) => call('GET', `/facility-transfers?facilityId=${facilityId}`, token);
export const startTransfer = (facilityId, toEmail, token) => call('POST', '/facility-transfers', token, { facilityId, toEmail });
export const resendTransfer = (id, token) => call('POST', `/facility-transfers/${id}/resend`, token, {});
export const cancelTransfer = (id, token) => call('DELETE', `/facility-transfers/${id}`, token);
export const getClaim = (token) => call('GET', `/public/facility-transfer/${encodeURIComponent(token)}`);
export const acceptClaim = (token, authToken) => call('POST', `/facility-transfers/claim/${encodeURIComponent(token)}/accept`, authToken, {});

const ERRORS = {
  INVALID_EMAIL: 'Adresse e-mail invalide.',
  ALREADY_OWNER: 'Cette personne est déjà propriétaire de l’établissement.',
  NOT_ALLOWED: 'Seuls l’ambassadeur de l’établissement et les administrateurs peuvent le transférer.',
  FACILITY_NOT_FOUND: 'Établissement introuvable.',
  TRANSFER_NOT_FOUND: 'Ce lien n’est pas valide (ou une nouvelle invitation l’a remplacé).',
  TRANSFER_EXPIRED: 'Cette invitation a expiré. Demandez à votre contact QRProofs de vous la renvoyer.',
  TRANSFER_CANCELLED: 'Cette invitation a été annulée.',
  TRANSFER_ACCEPTED: 'Cette invitation a déjà été acceptée.',
  EMAIL_NOT_VERIFIED: 'Confirmez d’abord votre adresse e-mail (lien reçu à la création du compte), puis revenez sur cette page.',
  WRONG_ACCOUNT: 'Vous êtes connecté avec un autre compte que celui invité.',
};
export const transferErrorText = (err) => ERRORS[err?.message] ?? 'Une erreur est survenue, réessayez.';
export const transfersOverview = (token) => call('GET', '/facility-transfers/overview', token);
